import type { LiteralUnion } from "type-fest";

export const partners = [
    "aafes",
    "adt",
    "amazonrouter",
    "asurion",
    "asurionhomeplus",
    "asuriontechcare",
    "att",
    "attconnectedhome",
    "bluestream",
    "brightspeed",
    "cox",
    "cricket",
    "dell",
    "dish",
    "expertuniversity",
    "fios",
    "frontier",
    "hotwire",
    "koodo",
    "leakprotect",
    "liberty",
    "life360",
    "mcafee",
    "mediacom",
    "microsoft",
    "nexcom",
    "nrg",
    "optimum",
    "optimumbiz",
    "others",
    "pilot",
    "reach",
    "samsungna",
    "smartpay",
    "sparklight",
    "staples",
    "staplessmb",
    "telus",
    "telushomepro",
    "thesource",
    "tmobile",
    "tracfone",
    "unknown",
    "uscellular",
    "verizon",
    "verizonconnectedhome",
    "viasat",
    "vzwsmb",
    "xboxcareplus",
    "yahoo",
    "demo",
] as const;
/** known partner or any string */
export type Partner = LiteralUnion<(typeof partners)[number], string>;
